export default __webpack_public_path__ + "files/8ec32a56e8d8253f1b497e71350bce3c.mp3";